<template>
	<div style="display:flex; align-items:center; gap:20px; white-space: nowrap;">
		<span style="font-size:14px;" v-if="!isSave">《{{ courseName }}》</span>
		<span style="font-size:14px;"
			v-if="isSave">观课:《{{ (courseName || '').includes('在线') ? (courseName || '').split('在线')[0] : (courseName || '') }}》</span>
		<!-- <span style="font-size:14px;" v-if="!isSave">主讲：{{ teacherName }}</span> -->
		<span style="font-size:14px;" v-if="!isSave">在线：{{ onlineCount}} 人</span>
		<div v-if="!isSave&&(time!=0&&time!=null)" @click="countdown" style="height: 100%;">
			<img src="@/ico/stutas/countdownStop.svg" style="width:24px;height: 24px;" alt="倒计时">
			{{ minute }}:{{ second }}
		</div>
	</div>
</template>

<script>
	export default {
		name: "ClassInformation",
		props: {
			courseName: {
				type: String,
				default: ""
			},
			teacherName: {
				type: String,
				default: ""
			},
			onlineCount: {
				type: Number,
				default: 0
			},
			isSave: {
				type: Boolean,
				default: false
			},
			time: {
				type: [String, Number],
				default: 0
			},
			timestop: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				minute: "00",
				second: "00",
				timer: null,
				remainTime: 0,
				countdownAudio: new Audio(require('@/mp3/10.flac'))
			}
		},
		watch: {
			// 监听 time 变化，自动开始倒计时
			time: {
				immediate: true,
				handler(val) {
					this.startCountdown(Number(val))
				}
			},
			timestop: {
				immediate: true,
				handler(val) {
					if (val) {
						if (this.timer) clearInterval(this.timer)
					}
				}
			},
		},
		created() {
			
			
		},
		methods: {
			playCountdownAudio() {
				try {
					// 每次播放都从头开始
					this.countdownAudio.currentTime = 0
					this.countdownAudio.play()
				} catch (e) {
					console.log('音频播放失败', e)
				}
			},
			// [2026-05-26] 定时管理：倒计时自动通知学生端
			// 当倒计时到达特定时间点（120秒、60秒、10秒、0秒）时，向学生端推送通知
			async countDownMsg(time) {
				
				// time 单位：秒
				let endTimestamp = Date.now(); // 当前推送的时间戳
				let noticeText = '';

				// 根据剩余时间生成对应的提示文本
				if (time === 0) {
					noticeText = '0'; // 时间到，触发闹钟弹窗
				} else if (time < 60) {
					// 小于60秒 → 显示秒
					noticeText = `${time}`;
				} else {
					// 大于等于60秒 → 显示分钟和秒
					let minute = Math.floor(time / 60);
					let second = time % 60;
					noticeText = `${minute * 60 + second}`; // 保持秒数格式，学生端会解析显示
				}
				if(!localStorage.getItem('PID')&&localStorage.getItem('isSave')=='false'){
					
					let res = await this.API.post(this.API.school.pushCountDown, {
						courseClassId: localStorage.getItem('courseClassId'),
						endTimestamp: endTimestamp,
						noticeText: noticeText==1?0:noticeText
					});
					
				}
			},
			countdown() {
				this.$emit('toCountdown', true)
			},
			// 启动倒计时
			startCountdown(totalSec) {
				this.formatTime(totalSec)
				let toTimeList = [120, 60, 10, 1]
				if (totalSec == 10) {
					this.playCountdownAudio()
				}
				if (toTimeList.filter(v => v == totalSec).length > 0) {
					let ToTime = totalSec
					this.countDownMsg(ToTime)
				}
				return
				// [2026-05-26] 定时管理：在特定时间点触发广播通知
				// 120秒、60秒、10秒、0秒时向学生端发送倒计时通知

				// 清除旧定时器
				if (this.timer) clearInterval(this.timer)
				if (totalSec <= 0) {
					this.formatTime(0)
					return
				}

				this.remainTime = totalSec
				this.formatTime(this.remainTime)

				// 每秒减1
				// this.timer = setInterval(() => {
				// 	if (this.timestop) return;
				// 	this.remainTime--

				// 	this.formatTime(this.remainTime)

				// 	// [2026-05-26] 定时管理：每秒检查是否到达需要通知的时间点
				// 	if (toTimeList.filter(v => v == this.remainTime).length > 0) {
				// 		this.countDownMsg(this.remainTime)
				// 	}

				// 	// 倒计时结束
				// 	if (this.remainTime <= 0) {
				// 		clearInterval(this.timer)
				// 		this.timer = null
				// 	}
				// }, 1000)
			},
			// 格式化 分:秒
			formatTime(seconds) {
				const m = Math.floor(seconds / 60)
				const s = seconds % 60
				this.minute = String(m).padStart(2, '0')
				this.second = String(s).padStart(2, '0')
			}
		},
		beforeDestroy() {
			// 页面销毁清除定时器
			if (this.timer) clearInterval(this.timer)
			if (this.countdownAudio) {
				this.countdownAudio.pause()
			}
		}
	}
</script>

<style>
</style>